// web/src/features/account/sportsPaySignUp/hooks/useSportsPayUrl.ts
import { useMutation } from '@tanstack/react-query'
import { getSportsPayUrl } from '@sportninja/common/services/account'

/**
 * Fetches the hosted SportsPay registration URL for an organization.
 *
 * A MUTATION rather than a query on purpose: it fires on an explicit click, not
 * on mount, and the URL is single-use in spirit — it carries a callback and
 * prefill built for that moment, so caching or refetching it in the background
 * would be wrong.
 *
 * `retry: 0` keeps a failed click from silently firing again; the caller
 * surfaces the error and the user can press the button once more.
 */
export const useSportsPayUrl = (organizationId: string | undefined) =>
  useMutation<string | undefined, Error, void>({
    mutationFn: () => getSportsPayUrl(organizationId as string),
    retry: 0,
  })
